import { section } from "framer-motion/client";
import { FaLaptopCode, FaCogs } from "react-icons/fa";

export const sidebarMenu = [
    {
      title: "Explore Netraa",
      icon: <FaLaptopCode />,
      items: [],
      section: "exploreNetraa",
    },
    {
      title: "Platform",
      icon: <FaCogs />,
      items: [
        {
          title: "Netraa APM", section:"netraaApmLanding",
          items: [
            { title: "Getting Started", section: "gettingStarted", items: [] },
            { title: "Quick Start", section: "quickStart", items: [] },
    
  {
    "title": "Analyze & Explore",
    "items": [
      {
        "title": "Apps",
        "section": "apps",
        "items": [
          {
            "title": "Home",
            "items": [
              { "title": "Services", "section": "homeservices" },
              // { "title": "Overview", "section": "home-overview" }
            ]
          },
          // {
          //   "title": "Dashboard",
          //   "items": [
          //     { "title": "Custom Dashboard", "section": "dashboard-custom" }
          //   ]
          // },
          {
            "title": "Infrastructure",
            "items": [
              { "title": "Host", "section": "infrahost", isNew: true   },
              { "title": "Redis", "section": "infraredis", isNew: true   },
          //     { "title": "NGNIX", "section": "infra-ngnix" },
          //     { "title": "IIS", "section": "infra-iis" }
            ]
          },
          {
            "title": "Database", "section":"db", isNew: true  ,
            "items": [
              // { "title": "Relational", "section": "dbrelational" },
          //     { "title": "Non-relational", "section": "db-nonrelational" }
            ]
          },
          // {
          //   "title": "RUM",
          //   "items": [
          //     { "title": "BRUM", "section": "rum-brum" },
          //     { "title": "MRUM", "section": "rum-mrum" }
          //   ]
          // },
          // {
          //   "title": "Cloud",
          //   "items": [
          //     { "title": "API Gateway", "section": "cloud-apigateway" },
          //     { "title": "EKS", "section": "cloud-eks" },
          //     { "title": "RDS", "section": "cloud-rds" },
          //     { "title": "AKS", "section": "cloud-aks" }
          //   ]
          // },
          // {
          //   "title": "Message Queue",
          //   "items": [
          //     { "title": "Active MQ", "section": "mq-activemq" },
          //     { "title": "Kafka", "section": "mq-kafka" },
          //     { "title": "Rabbit MQ", "section": "mq-rabbitmq" }
          //   ]
          // },
          // {
          //   "title": "Reports",
          //   "items": [
          //     { "title": "HTML Report", "section": "reports-html" }
          //   ]
          // },
          // {
          //   "title": "Configuration",
          //   "items": [
          //     { "title": "Admin-Config", "section": "configadmin", isNew: true }
          //   ]
          // },
          // {
          //   "title": "Alerts and Problems",
          //   "items": [
          //     { "title": "Alerts", "section": "alerts" },
          //     { "title": "Problems", "section": "problems" }
          //   ]
          // }
        ]
      }
    ]
  },
            { title: "Platform Overview", section: "platformOverview", items: [] },
            { title: "Core Concepts", section: "coreConcept", items: [] },
            {
              title: "Product Capabilities",
              items: [
                { title: "Overview", section: "appOverview" },
                { title: "APM – General Services", section: "generalServices" },
                { title: "Infrastructure Monitoring", section: "infraMonitoring" },
                { title: "Database Monitoring", section: "databaseMonitoring" },
                { title: "Real User Monitoring (RUM)", section: "browserMonitoring" },
                { title: "Message Queue Monitoring", section: "msgmq" },
                { title: "Alerting Module", section: "alert" },
                { title: "Reports", section: "report" },
              ],
            },
            { title: "Reporting & Analytics", section: "analytics" },
            { title: "Integrations", section: "integration",
              items: [
                { title: "ServiceNow", section: "servicenow", isNew: true },
              ],
             },
            {
  title: "Deployment-Setup",
  items: [
    { title: "Prerequisites", section: "prerequisitesAPM" },
    { title: "Offline Setup Guide", section: "netraaAPM" },

    {
      title: "Agent Setup Guide", section:"agentsetup",
      // section: "Agent",
      items: [
        {
          title: "Infra",
          items: [
            { title: "Linux", section: "agentlinux" },
            { title: "Windows", section: "agentwindows" },
          ],
        },

        {
           title: "Network", section: "network"
        },
        {
          title: "Technology Agent",
          items: [
            { title: "Java", section: "agentjava" },
            { title: "Python", section: "agentpython" },
            { title: ".Net", section: "agentdotnet" },
            { title: "PHP", section: "agentphp" },
            { title: "Node.js", section: "agentnodejs" },
            // { title: "Go", section: "agent-go" },
          ],
        },

        {
          title: "Database",
          items: [
            { title: "MySQL", section: "agentmysql" },
            { title: "MsSQL", section: "agentmssql" },
            { title: "Oracle", section: "agentoracle" },
            // { title: "Snowflake", section: "agent-snowflake" },
            // { title: "Cosmos", section: "agent-cosmos" },
            // { title: "PostgreSQL", section: "agent-postgresql" },
          ],
        },

        {
          title: "Message Queue",
          items: [
            { title: "ActiveMQ", section: "activemq" },
            { title: "Kafka", section: "agentkafka" },
          ],
        },

        {
          title: "Cloud",
          items: [
            {
              title: "Azure",
              items: [
                // { title: "AKS", section: "agent-azure-aks" },
                // { title: "Function App", section: "agent-azure-function" },
                // { title: "App Service", section: "agent-azure-appservice" },
                { title: "VMs", section: "agentazurevm" },
              ],
            },
            {
              title: "AWS",
              items: [
                { title: "EKS", section: "agentawseks" },
                // { title: "EC2", section: "agent-aws-ec2" },
                // { title: "Fargate", section: "agent-aws-fargate" },
                // { title: "Lambda", section: "agent-aws-lambda" },
                { title: "RDS", section: "agentawsrds" },
                { title: "AWS Gateway", section: "agentawsgateway" },
              ],
            },
          ],
        },
      ],
    },

    { title: "Minimal Setup Guide", section: "Minimal" },
  ],
},
{
              title: "Release Notes",
              items: [
                { title: "Release Notes 2026.09", section: "releasenotesAPMv6", isNew: true  },
                { title: "Release Notes 2026.08", section: "releasenotesAPMv5" },
                { title: "Release Notes 2026.07", section: "releasenotesAPMv4" },
                { title: "Release Notes 2026.06", section: "releasenotesAPMv3" },
                { title: "Release Notes 2026.05", section: "releasenotesAPMv2" },
                { title: "Release Notes 2026.04", section: "releasenotesAPM" },
                // { title: "Release Notes v1.1", section: "releaseNotesv1.1" },
                // { title: "Release Notes v1.0", section: "releaseNotesv1.0" },
              ],
            },
{ title: "Use Cases", path: "/usecasesAPM" }
      ],
        },
        {
          title: "Netraa LH",
          items: [
            { title: "Introduction", section: "netraaLH" },
            {
              title: "Product Capabilities",
              items: [
                { title: "Dashboard", section: "Dashboard" },
                { title: "Availability", section: "Availability" },
                { title: "Errors & SLA", section: "ErrorSLA" },
                { title: "Reports", section: "reportLH" },
                { title: "Global Industry Benchmarking", section: "netraaLHConcepts" },
              ],
            },
            {
              title: "Release Notes",
              items: [
                { title: "Release Notes v1.6", section: "releaseNotesv1.6" },
                { title: "Release Notes v1.5", section: "releaseNotesv1.5" },
                { title: "Release Notes v1.4", section: "releaseNotesv1.4" },
                { title: "Release Notes v1.3", section: "releaseNotesv1.3" },
                { title: "Release Notes v1.2", section: "releaseNotesv1.2" },
                { title: "Release Notes v1.1", section: "releaseNotesv1.1" },
                { title: "Release Notes v1.0", section: "releaseNotesv1.0" },
              ],
            },
            { title: "Use Cases", path: "/usecasesLH" }
            // {
            //   title: "Deployment-Setup",
            //   items: [
            //     { title: "LH Development Setup", section: "LHSetup" },
            //   ],
            // },
          ],
        },
        // { title: "Netraa SRG", items: [{ title: "Getting Started", section: "netraaSRG" }] },
        {
          title: "Netraa AI OPS Assistant",
          items: [
            { title: "Platform Overview", section: "AiOverview", items: [] },
            {
              title: "Product Capabilities",
              items: [
                // { title: "Multitool Event Correlation ", section: "multitool" },
                { title: "Universal Event Correlation", section: "correlation" },
                { title: "Gen-AI Driven Interpretive Intelligence", section: "genAi" },
                { title: "RAG Documentation Intelligence", section: "ragDoc" },
                { title: "Predictive Modeling with Seasonality", section: "predictiveModeling" },
                { title: "Causal AI for True RCA", section: "causalAi" },
                // { title: "Automated Topology Mapping", section: "topology" },
                // { title: "Reports", section: "report" },
              ],
            },
            { title: "Integrations", section: "AiOpsintegration" },
            { title: "Deployment-Setup", section: "AiopsSetup"},
            // { title: "UseCases", path: "/usecasesAIOPS" }
          ],
        },
      ],
    },
  ];
